import { createBrowserRouter } from 'react-router-dom'
import App from '../App'
import Home from '../pages/Home'
import Login from '../pages/Login'
import ForgotPassowrd from '../pages/ForgotPassowrd'
import SignUp from '../pages/SignUp'
import AdminPanel from '../pages/AdminPanel'
import AdminPanelPersonalInfo from '../pages/AdminPanelPersonalInfo'
import AllUsers from '../pages/AllUsers'
import AllProducts from '../pages/AllProducts'
import CategoryProduct from '../pages/CategoryProduct'
import ProductDetails from '../pages/ProductDetails'
import Cart from '../pages/Cart'
import SearchProduct from '../pages/SearchProduct'
import ResetPassword from '../pages/ResetPassword'
import OTPCheck from '../pages/OTPCheck'
import PaymentPage from '../pages/Payment'
import UserProfile from '../pages/UserProfile'
import UserPaymentRequest from '../pages/UserPaymentRequest'
import UserEditProfile from '../pages/UserEditProfile'
import ChangePassword from '../pages/ChangePassword'
import OrderPage from '../pages/OrderPage'
import PaymentHistory from '../pages/PaymentHistory'
import AdminProfile from '../pages/AdminProfile'
import AdminEditProfile from '../pages/AdminEditProfile'
import AdminChangePassword from '../pages/AdminChangePassword'
import AdminViewUserRequest from '../pages/AdminViewUserRequest'
import AdminViewUserOrders from '../pages/AdminViewUserOrders'
import AdminAllOrders from '../pages/AdminAllOrders'
import AdminAllRequests from '../pages/AdminAllRequests'
import AdminHome from '../pages/AdminHome'
import AdminCategoryProduct from '../pages/AdminCategoryProduct'
import AdminSearchProduct from '../pages/AdminSearchProduct'
import AdminProductDetails from '../pages/AdminProductDetails'
import AdminCosmeticCategoryProduct from '../pages/AdminCosmeticCategoryProduct'
import AdminCosmeticHome from '../pages/AdminCosmeticHome'
import AdminCosmeticProductDetails from '../pages/AdminCosmeticProductDetails'
import AdminCosmeticSearchProduct from '../pages/AdminCosmeticSearchProduct'
import UserVerifyEmail from '../pages/UserVerifyEmail'
import PaymentOTPVerify from '../pages/paymentOTPVerify'
import SalesManPanel from '../pages/SalesManPanel'
import SalesManPanelPersonalInfo from '../pages/SalesManPanelPersonalInfo'
import SalesManProfile from '../pages/SalesManProfile'
import SalesManEditProfile from '../pages/SalesManEditProfile'
import SalesManChangePassword from '../pages/SalesManChangePassword'
import SalesManViewPayments from '../pages/SalesManViewPayments'
import SalesManViewOrders from '../pages/SalesManViewOrders'
import SalesManViewOrder from '../pages/SalesManViewOrder'
import UserViewOrderDetails from '../pages/UserViewOrderDetails'
import UserPaymentAndOrdersHistory from '../pages/UserPaymentAndOrdersHistory'
//import UserCosPaymentAndOrdersHistory from '../pages/UserCosPaymentAndOrdersHistory'
import AdminAllRefunds from '../pages/AdminAllRefunds'
import AdminPaymentAndOrders from '../pages/AdminPaymentAndOrders'
import AdminViewAnOrder from '../pages/AdminViewAnOrder'
import UserAllRefunds from '../pages/UserAllRefunds'
import Advertisements from '../pages/Advertisements'
import AdminBossSearchProduct from '../pages/AdminBossSearchProduct'
import SalesmanPaymentRequest from '../pages/SalesmanPaymentRequest'
import SalesmanPaymentPage from '../pages/SalesmanPayment'
import SalesManPaymentOTPVerify from '../pages/SalesManPaymentOTPVerify'
import SalesmanAllUsers from '../pages/SalesmanAllUsers'
import SalesmanViewUserOrders from '../pages/SalesmanViewUserOrders'
import SalesManViewUserOrderDetails from '../pages/SalesManViewUserOrderDetails'







const router = createBrowserRouter([
    {
        path : "/",
        element : <App/>,
        children : [
            {
                path : "",
                element : <Home/>
            },
            {
                path : "login",
                element : <Login/>
            },
            {
                path : "forgot-password",
                element : <ForgotPassowrd/>
            },
            {
                path : "userResetPassword",
                element :<ResetPassword/>
            },
            {
                path : "OTPCheck",
                element :<OTPCheck/>
                
            },
            {
                path : "sign-up",
                element : <SignUp/>
            },
            {
                path : "UserVerifyEmail",
                element : <UserVerifyEmail/>
            },

            {
                path : "product-category",
                element : <CategoryProduct/>
            },
            {
                path : "product/:id",
                element : <ProductDetails/>
            },
            {
                path : 'cart',
                element : <Cart/>
            },
            {
                path : "search",
                element : <SearchProduct/>
            },
            {
                path : "payment",
                element : <PaymentPage/>
            },
            {
            path : "payment-salesman",
            element : <SalesmanPaymentPage/>
            },
            {
                path : "userProfile",
                element : <UserProfile/>
            },
            {
                path : "userPaymentRequest",
                element : <UserPaymentRequest/>
            },
            {
                path : "salesmanPaymentRequest",
                element : <SalesmanPaymentRequest/>
            },
            {
                path : "salesManPaymentOTPVerify",
                element : <SalesManPaymentOTPVerify/>
            },
            
    
            {
                path : "paymentOTPVerify",
                element : <PaymentOTPVerify/>
            },

            {
                path : "userEditProfile",
                element : <UserEditProfile/>
            },
            
            {
                path : "changePassword",
                element : <ChangePassword/>
            },
            {
                path : "order-history",
                element : <OrderPage/>
            },
            {
            path : "paymentHistory",
            element : <PaymentHistory/>
            },
            {
            path : "admin-home",
            element : <AdminHome/>
            },
            {
            path : "admin-category-product",
            element : <AdminCategoryProduct/>
            },
            {
            path : "admin-search-product",
            element : <AdminSearchProduct/>
            },
            {
            path : "admin-product/:id",
            element : <AdminProductDetails/>
            },
            {
            path : "admin-cosmetic-home",
            element : <AdminCosmeticHome/>
            },
            {
            path : "admin-cosmetic-category-product",
            element : <AdminCosmeticCategoryProduct/>
            },
            {
            path : "admin-search-cosmetic-product",
            element : <AdminCosmeticSearchProduct/>
            },
            {
            path : "admin-boss-search-product",
            element : <AdminBossSearchProduct/>
            },
            {
            path : "admin-cosmetic-product/:id",
            element : <AdminCosmeticProductDetails/>
            },
            {
                path: "userViewOrderDetails/:id/:type",
                element: <UserViewOrderDetails />
            },
            {
                path : "userPaymentAndOrdersHistory",
                element : <UserPaymentAndOrdersHistory/>
            },
            /*
            {
                path : "userCosPaymentAndOrdersHistory",
                element : <UserCosPaymentAndOrdersHistory/>
            },
            */
            {
                path : "userRefundRequests",
                element : <UserAllRefunds/>
            },
            

            {
                path : "SalesManPanelPersonalInfo",
                element : <SalesManPanelPersonalInfo/>,
                children : [
                    {
                        path : "salesManProfile",
                        element : <SalesManProfile/>
                    },
                    {
                        path : "salesManEditProfile",
                        element : <SalesManEditProfile/>
                    },
                    {
                        path : "salesManChangePassword",
                        element : <SalesManChangePassword/>
                    }
        
                ]
            },


            {
                path : "salesManPanel",
                element : <SalesManPanel/>,
                children : [
                   
                    {
                        path : "salesManViewPayments",
                        element : <SalesManViewPayments/>
                    },
                    {
                        path : "salesManViewOrders",
                        element : <SalesManViewOrders/>
                    },
                    {
                        path: "salesManViewOrder/:id",
                        element: <SalesManViewOrder />
                    },
                    {
                        path: "salesmanAllUsers",
                        element: <SalesmanAllUsers />
                    },
                    {
                        path : "salesmanViewUserOrders/:userId",
                        element : <SalesmanViewUserOrders/>
                    },
                    {
                        path : "salesManViewUserOrderDetails/:id/:type",
                        element : <SalesManViewUserOrderDetails/>
                    },
                    
                    
                    

                    

                    
                    

                    


                    
                ]
            },


            {
                path : "AdminPanelPersonalInfo",
                element : <AdminPanelPersonalInfo/>,
                children : [

                    {
                        path : "adminProfile",
                        element : <AdminProfile/>
                    },
                    {
                        path : "adminEditProfile",
                        element : <AdminEditProfile/>
                    },
                    {
                        path : "adminChangePassword",
                        element : <AdminChangePassword/>
                    },                 
                ]
            },


            {
                path : "admin-panel",
                element : <AdminPanel/>,
                children : [
                    {
                        path : "all-users",
                        element : <AllUsers/>
                    },
                    {
                        path : "all-products",
                        element : <AllProducts/>
                    },
                    {
                        path : "adminViewUserRequest/:userId",
                        element : <AdminViewUserRequest/>
                    },
                    {
                        path : "adminViewUserOrders/:userId",
                        element : <AdminViewUserOrders/>
                    },
                    {
                        path : "admin-all-orders",
                        element : <AdminAllOrders/>
                    },
                    {
                        path : "admin-all-requests",
                        element : <AdminAllRequests/>
                    },
                    {
                        path : "adminPaymentAndOrders/:userId",
                        element : <AdminPaymentAndOrders/>
                    },
                    {
                        path : "adminViewAnOrder/:userId/:type",
                        element : <AdminViewAnOrder/>
                    },
                    {
                        path : "admin-all-refunds",
                        element : <AdminAllRefunds/>
                    },
                    {
                        path : "advertisements",
                        element : <Advertisements/>
                    },

                    
                    

                    
                ]
            },
        ]
    }
])


export default router